import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-black/10 bg-white mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 bg-[#111111] flex items-center justify-center">
              <span className="text-white font-serif font-black text-xl leading-none">D</span>
            </div>
            <span className="font-serif font-black text-2xl tracking-tight">DealHub</span>
          </div>
          <p className="text-sm text-black/60 max-w-md leading-relaxed">
            An editorial guide to the best deals on the web. Travel, fashion, autos, stocks, crypto, and everything in between — curated daily.
          </p>
        </div>

        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-black/50 mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/category/travel" className="hover:text-[#E63946]">Travel</Link></li>
            <li><Link to="/category/clothing" className="hover:text-[#E63946]">Clothing</Link></li>
            <li><Link to="/category/stocks" className="hover:text-[#E63946]">Stocks</Link></li>
            <li><Link to="/category/crypto" className="hover:text-[#E63946]">Crypto</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-black/50 mb-3">Account</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="hover:text-[#E63946]">Log In</Link></li>
            <li><Link to="/register" className="hover:text-[#E63946]">Sign Up</Link></li>
            <li><Link to="/bookmarks" className="hover:text-[#E63946]">Bookmarks</Link></li>
            <li><Link to="/submit" className="hover:text-[#E63946]">Submit a Deal</Link></li>
            <li><Link to="/leaderboard" className="hover:text-[#E63946]">Contributors Board</Link></li>
            <li><Link to="/preferences" className="hover:text-[#E63946]">Preferences</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-black/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-black/50 font-mono uppercase tracking-widest">
          <span>© {new Date().getFullYear()} DealHub Editorial</span>
          <span>Deals refreshed daily · Live crypto by CoinGecko</span>
        </div>
      </div>
    </footer>
  );
}
